import React, { useState, useEffect } from 'react';
import { Box, Divider } from '@mui/material';
import SalesDashboard from './widgets/SalesDashboard';
import { getDashboard } from '../services/dashboardService';
import Loading from './widgets/Loading';
import Retry from './widgets/Retry';
import SalesSummary from './widgets/SalesSummary';
import Filters from './widgets/Filters';
import { useTranslation } from 'react-i18next';

function Dashboard({ user }) {

    const { t } = useTranslation();

    const [lastUpdate, setLastUpdate] = useState(Date.now());
    const [dashboard, setDashboard] = useState({});
    const [error, setError] = useState("");
    const [selectedPlatforms, setSelectedPlatforms] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [clickId, setClickId] = useState('');
    const [startDate, setStartDate] = useState(() => {
        const today = new Date(Date.now() - 180 * 24 * 60 * 60 * 1000); // Half a year ago
        return today.toISOString().split('T')[0]; 
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    });

    useEffect(() => {
        loadDashboard();
    
        // Schedule loadDashboard every 5 minutes
        const interval = setInterval(loadDashboard, 5 * 60 * 1000);
    
        // Cleanup the interval on component unmount
        return () => clearInterval(interval);
    }, []);

    const loadDashboard = async () => {
        try {
            setError("");
            setIsLoading(true);
            const dashboardData = await getDashboard(user._id, startDate, endDate, selectedPlatforms.join(","), clickId);
            setLastUpdate(Date.now());
            setDashboard(dashboardData);
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (    
        <Box>
            <Filters
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                platforms={dashboard.filters?.platforms}
                selectedPlatforms={selectedPlatforms}
                setSelectedPlatforms={setSelectedPlatforms}
                clickIds={dashboard.filters?.clickIds}
                clickId={clickId}
                setClickId={setClickId}
                onReload={loadDashboard}
                lastUpdate={lastUpdate}
            />
            <Divider/>
            {
            error !== "" 
            ? (<Retry message={error} onClick={loadDashboard} />) 
            : ( 
            <>
                <Box
                    sx={{
                        display: { sm: 'block', md: 'flex' },
                        alignItems: 'top'
                    }}
                >
                    {/* Left Section */}
                    {isLoading === false && 
                        <SalesDashboard dashboard={dashboard}/>
                    }   

                    {/* Right Section */}
                    {isLoading === false && 
                        <SalesSummary dashboard={dashboard} />
                    }
                </Box>
            </>
        )}
        <Loading text={t('dashboard.loading')} isLoading={isLoading} />
        </Box>
    );
}

export default Dashboard;